import type { FiltersState } from '../../hooks/useFilters';
import { avitoSourceModule } from '../avito';
import type { SourceModule, SourceVacancyParams } from './types';

const sourceModuleRegistry: Record<string, SourceModule> = {
  avito: avitoSourceModule,
};

export function getSourceModule(source: string): SourceModule | undefined {
  return sourceModuleRegistry[source];
}

export function getRegisteredSourceModules(): SourceModule[] {
  return Object.values(sourceModuleRegistry);
}

export function hasSourceVacancyMapper(source: string): boolean {
  return Boolean(getSourceModule(source)?.filters?.fromVacancy);
}

export function normalizeSourceVacancyList(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map(String).map((item) => item.trim()).filter(Boolean);
  }

  if (typeof value === 'string' && value.trim()) {
    return value.split(',').map((item) => item.trim()).filter(Boolean).map(String);
  }

  return [];
}

export function mapSourceVacancyToFilters(
  source: string,
  params: SourceVacancyParams,
): Partial<FiltersState> {
  const fromVacancy = getSourceModule(source)?.filters?.fromVacancy;
  if (fromVacancy) {
    return fromVacancy(params);
  }

  return {
    selectedSpecializations: normalizeSourceVacancyList(params.vacancy.specialization),
  };
}

export function applySourceVacancyFilters(
  source: string,
  filters: Partial<FiltersState>,
  params: SourceVacancyParams,
): Partial<FiltersState> {
  const module = getSourceModule(source);
  const next = {
    ...filters,
    ...mapSourceVacancyToFilters(source, {
      ...params,
      filters,
    }),
  };

  return module?.filters?.sanitize
    ? module.filters.sanitize(next)
    : next;
}

export { avitoSourceModule };
export type {
  SourceFilterBucketId,
  SourceFilterModule,
  SourceModule,
  SourceSwitchParams,
  SourceTransferParams,
  SourceVacancyParams,
} from './types';
